export function loadCdnScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {

    // Prevent duplicate loading
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () => reject(`Failed to load ${src}`);

    document.head.appendChild(script);
  });
}
